import styled from 'styled-components';

import withUnit from 'utils/cssInJs/withUnit';
import { getThemeProp } from 'theme';

interface IProps {
  width?: number;
  height?: number;
}

const Line = styled.span`
  & {
    background-color: ${getThemeProp('colors.mercuryGrey')};
    border-radius: 3px 3px;
    display: block;

    ${({ width = 100, height = 12 }: IProps) => `
      width: ${withUnit(width)};
      height: ${withUnit(height)};
    `}
  }
`;

export default Line;
